import { IWidgetAnimationData } from "@pageBuilder/typings";
import { CssProperties, ICssProperty } from "../../models/css-property";
import { ElementStyleService } from "../../services/element-style.service";

export class WidgetAnimationRenderer {

    constructor(protected readonly styleService: ElementStyleService) {
    }

    public setAnimationStyles(element: HTMLElement, style?: IWidgetAnimationData): void {
        if (style?.animationSource === "widget") {
            const elementProps = new CssProperties();
            elementProps.tryAdd("--current-widget-animation-name", style?.animationData.name);
            elementProps.tryAdd("--current-widget-animation-duration", `${style?.animationData.duration}s`);
            this.styleService.setStyle(element, `#${element.id}`, elementProps.data);
        }

        this.setAnimationSource(element, style?.animationSource ?? "none");
    }

    public getAnimationStyles(style?: IWidgetAnimationData): ICssProperty[] | null {
        if (style?.animationSource === "widget") {
            const elementProps = new CssProperties();
            elementProps.tryAdd("--current-widget-animation-name", style?.animationData.name);
            elementProps.tryAdd("--current-widget-animation-duration", `${style?.animationData.duration}s`);
            return elementProps.data;
        }

        return null;
    }

    public setAnimationSource(element: HTMLElement, animationSource: string): void {
        element.dataset.animationSource = animationSource;
    }

}
